/* eslint-disable max-statements */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Form } from './Form';

import { MobileStepper, Stepper, Step, StepLabel, StepContent, Button } from '@material-ui/core/';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	button: {
		marginTop: theme.spacing(1),
		marginRight: theme.spacing(1)
	},
	actionsContainer: {
		display: 'flex',
		flexDirection: 'row-reverse',
		marginBottom: theme.spacing(2)
	}
}));

export const FlowWizard = ({ steps, showMobile, initialStep, validate, onSubmit }) => {
	console.log('steps', steps);

	const classes = useStyles();

	const [currentStep, setCurrentStep] = useState(initialStep);
	const [buttonsLayoutVisible, setButtonsLayoutVisible] = useState(true);

	const lastStep = steps.length - 1;
	const activeStep = steps[currentStep];
	const initialValues = activeStep && activeStep.initialValues;
	const validationSchema = activeStep && activeStep.validationSchema;
	const validateOnBlur = (activeStep && activeStep.validateOnBlur) || true;
	const ActiveComponent = activeStep && activeStep.component;
	const activeComponentProps = (activeStep && activeStep.props) || {};

	const handlePrevStep = () => {
		const step = Math.max(currentStep - 1, 0);

		setCurrentStep(step);
	};

	const handleNextStep = ({ validateForm }) => (e) => {
		if (validate) {
			const validStep = validateForm();

			if (!validStep) {
				return;
			}
		}
		const step = Math.min(currentStep + 1, lastStep);

		setCurrentStep(step);
	};

	return (
		<Form
			onSubmit={onSubmit}
			initialValues={initialValues}
			validateOnBlur={validateOnBlur}
			validationSchema={validationSchema}
		>
			{({
				values,
				errors,
				onChange,
				updateValue,
				onBlur,
				buildHandleSubmit,
				validateForm,
				validateField,
				resetErrors
			}) => (
					<div>
						{showMobile ? (
							<div>
								<div style={{ padding: '16px 16px' }}>
									<ActiveComponent
										{...activeComponentProps}
										values={values}
										updateValue={updateValue}
										errors={errors}
										onChange={onChange}
										onBlur={onBlur}
										validateField={validateField}
										setWizardButtonsVisibility={setButtonsLayoutVisible}
										resetErrors={resetErrors}
									/>
								</div>

								<MobileStepper
									style={{ position: 'fixed', bottom: '0', width: '100%' }}
									steps={steps.length}
									position="static"
									variant="dots"
									activeStep={currentStep}
									nextButton={
										<React.Fragment>
											{currentStep < (steps.length - 1) ?
												<Button size="small" onClick={handleNextStep({ validateForm })} disabled={currentStep === (steps.length - 1)}>
													Next
												<KeyboardArrowRight />
												</Button>
												: < Button
													className={classes.button}
													onClick={buildHandleSubmit()}
													variant="contained"
													color="primary"
												>
													Submit
												</Button>}
										</React.Fragment>
									}
									backButton={
										<Button size="small" onClick={handlePrevStep} disabled={currentStep === 0}>
											<KeyboardArrowLeft />
											Back
          									</Button>
									}
								/>
							</div>)
							: (<div>
								<Stepper activeStep={currentStep}>
									{steps.map((step, index) => (
										<Step key={step.name}>
											<StepLabel>{step.name}</StepLabel>

										</Step>
									))}
								</Stepper>
								<div style={{ width: '75%', margin: 'auto' }}>
									<ActiveComponent
										{...activeComponentProps}
										values={values}
										errors={errors}
										updateValue={updateValue}
										onChange={onChange}
										onBlur={onBlur}
										validateField={validateField}
										setWizardButtonsVisibility={setButtonsLayoutVisible}
										resetErrors={resetErrors}
									/>
								</div>
								<div className={classes.actionsContainer}>
									{buttonsLayoutVisible && (
										<div>
											<Button
												className={classes.button}
												onClick={handlePrevStep}
												disabled={currentStep === 0}
											>
												Back
                    								</Button>
											{currentStep === lastStep ? (
												<Button
													className={classes.button}
													onClick={buildHandleSubmit()}
													variant="contained"
													color="primary"
												>
													Submit
												</Button>
											) : (
													<Button
														className={classes.button}
														variant="contained"
														color="primary"
														onClick={handleNextStep({ validateForm })}
													>
														Continue
																			</Button>
												)}
										</div>
									)}
								</div>
							</div>)
						}
					</div>
				)
			}
		</Form>
	);
};

FlowWizard.defaultProps = {
	validate: true,
	initialStep: 0,
	nextButtonText: 'Next',
	nextButtonClass: '',
	backButtonText: 'Back',
	backButtonClass: '',
	lastStepButtonText: 'Submit'
};

FlowWizard.propTypes = {
	steps: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
		component: PropTypes.elementType,
		validationSchema: PropTypes.object,
		path: PropTypes.string,
		renderButtonsLayout: PropTypes.func,
		initialValues: PropTypes.object,
		validateOnBlur: PropTypes.bool
	})).isRequired,
	validate: PropTypes.bool,
	initialStep: PropTypes.number,
	renderButtonsLayout: PropTypes.func,
	onStepChange: PropTypes.func,
	onSubmit: PropTypes.func.isRequired
};
